var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "light",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m9.5 8h-8c-.827 0-1.5-.673-1.5-1.5v-5c0-.827.673-1.5 1.5-1.5h8c.827 0 1.5.673 1.5 1.5v5c0 .827-.673 1.5-1.5 1.5zm-8-7c-.275 0-.5.224-.5.5v5c0 .276.225.5.5.5h8c.275 0 .5-.224.5-.5v-5c0-.276-.225-.5-.5-.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m9.5 24h-8c-.827 0-1.5-.673-1.5-1.5v-11c0-.827.673-1.5 1.5-1.5h8c.827 0 1.5.673 1.5 1.5v11c0 .827-.673 1.5-1.5 1.5zm-8-13c-.275 0-.5.224-.5.5v11c0 .276.225.5.5.5h8c.275 0 .5-.224.5-.5v-11c0-.276-.225-.5-.5-.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m22.5 24h-8c-.827 0-1.5-.673-1.5-1.5v-5c0-.827.673-1.5 1.5-1.5h8c.827 0 1.5.673 1.5 1.5v5c0 .827-.673 1.5-1.5 1.5zm-8-7c-.275 0-.5.224-.5.5v5c0 .276.225.5.5.5h8c.275 0 .5-.224.5-.5v-5c0-.276-.225-.5-.5-.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m22.5 14h-8c-.827 0-1.5-.673-1.5-1.5v-11c0-.827.673-1.5 1.5-1.5h8c.827 0 1.5.673 1.5 1.5v11c0 .827-.673 1.5-1.5 1.5zm-8-13c-.275 0-.5.224-.5.5v11c0 .276.225.5.5.5h8c.275 0 .5-.224.5-.5v-11c0-.276-.225-.5-.5-.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.4dfd917fde2130511dc38a19517f4580.svg";
export { ForwardRef as ReactComponent };